import { ServerURL } from "./ServerURL";
import { disconnect } from './Cookies';
import { getSentence, getLanguage } from "./translations";
import { matomoEvent } from "./matomoTracker";



export async function connect(mail, passwd)
{
    var form = new FormData();    //formdata object

    form.append('email', mail);   //append the values with key, value pair
    form.append('password', passwd);
    
    var response = await fetch(ServerURL+"/login", {
        method: 'POST', 
        mode: 'cors', 
        body: form
    });

    response = await response.json();

    return response;
}


export async function logout()
{
    const response = await fetch(ServerURL + "/logout");
    disconnect()
    window.history.replaceState(null, "", "/")
    matomoEvent("logout", "web", "")
}

export async function isConnectedServer()
{
    //check if the user is connected on the server side.
    return Number(await fetch(ServerURL + "/is_connected"))
}

export async function signUp(mail, passwd)
{    
    var form = new FormData();    //formdata object

    form.append('email', mail);   //append the values with key, value pair
    form.append('password', passwd);
    form.append('navigator_language', getLanguage());

    var response = await fetch(ServerURL+"/signUp", {
        method: 'POST', 
        mode: 'cors', 
        body: form
    });

    response = await response.json();

    return response;
}

export async function updateEmail(newmail)
{    
    var form = new FormData();    //formdata object

    form.append('new_mail', newmail);

    var response = await fetch(ServerURL+"/update_mail", {
        method: 'POST', 
        mode: 'cors', 
        body: form
    });

    response = await response.json();
    matomoEvent("update email", "web", newmail)

    return response;
}


export async function updatePasswd(old_password, new_password)
{    
    var form = new FormData();    //formdata object

    form.append('old_password', old_password);
    form.append('new_password', new_password);

    var response = await fetch(ServerURL+"/update_passwd", {
        method: 'POST', 
        mode: 'cors', 
        body: form
    });
    matomoEvent("update password", "web", "")

    response = await response.json();

    return response;
}


export async function checkpasswd(passwd)
{
    const response = await fetch(ServerURL + "/check_passwd/" + passwd);
    const correct = await response.json();
    return correct;
}



export async function createMeeting()
{
    const response = await fetch(ServerURL + "/new_meeting/" + getSentence(48));
    const meeting_id = await response.json();
    return meeting_id;
}

export async function listMeeting(orderBy = 'id', desc = 1)
{
    
    const response = await fetch(ServerURL + `/list_meetings/${encodeURIComponent(orderBy)}/${desc}`);
    const meeting_list = await response.json();
    return meeting_list;
}

export async function searchMeetings(keywords, fields, orderBy, desc)
{
    fields = fields.replace("participants", "speaker")
    const response = await fetch(ServerURL + `/search/${encodeURIComponent(keywords)}/${encodeURIComponent(fields)}/${encodeURIComponent(orderBy)}/${desc}`);
    const search_results = await response.json();
    return search_results;
}


export async function getMeeting(meeting_id)
{
    const response = await fetch(ServerURL + "/get_meeting/" + meeting_id);
    const meeting = await response.json();
    return meeting;
}


export async function like(meeting_id, like)
{
    /* 
        like : boolean.
        Will like the meeting if like=true. Will unlike the meeting otherwise. 
    */
    const response = await fetch(ServerURL + "/favorite/" + meeting_id + "/" + like);
    /* maybe should wait confirmation from the server side ? */
    matomoEvent("like", meeting_id, like)
}

export async function delete_meeting(meeting_id)
{
    /* 
        Will delete the meeting on the server-side. 
    */
    const response = await fetch(ServerURL + "/delete_meeting/" + meeting_id);
    //window.location.reload(true);
    /* maybe should wait confirmation from the server side ? */
    matomoEvent("delete meeting", "web", meeting_id)
}

export async function getRemainingTime()
{
    const response = await fetch(ServerURL + "/get_remaining_time");
    const remainingTime = await response.json();
    return remainingTime;
}

export async function updateTranscription(meeting_id, new_transcription)
{    
    var form = new FormData();    //formdata object

    form.append('meeting_id', meeting_id);
    new_transcription = await JSON.stringify(new_transcription)
    form.append('new_transcription', new_transcription);


    var response = await fetch(ServerURL+"/update_transcription", {
        method: 'POST', 
        mode: 'cors', 
        body: form
    });

    response = await response.json();
    matomoEvent("update transcription", "web", meeting_id)

    return response;
}


export async function updateSummary(meeting_id, new_summary)
{    
    var form = new FormData();    //formdata object

    form.append('meeting_id', meeting_id);
    form.append('new_summary', new_summary);


    var response = await fetch(ServerURL+"/update_summary", {
        method: 'POST', 
        mode: 'cors', 
        body: form
    });

    response = await response.json();
    matomoEvent("update summary", "web", meeting_id)

    return response;
}



export async function updateKeypoints(meeting_id, new_keypoints)
{    
    var form = new FormData();    //formdata object

    form.append('meeting_id', meeting_id);
    form.append('new_keypoints', new_keypoints);


    var response = await fetch(ServerURL+"/update_keypoints", {
        method: 'POST', 
        mode: 'cors', 
        body: form
    });

    response = await response.json();
    matomoEvent("update keypoints", "web", meeting_id)

    return response;
}


export async function updateTitle(meeting_id, new_title)
{    
    var form = new FormData();    //formdata object

    form.append('meeting_id', meeting_id);
    form.append('new_title', new_title);


    var response = await fetch(ServerURL+"/update_title", {
        method: 'POST', 
        mode: 'cors', 
        body: form
    });

    response = await response.json();
    matomoEvent("update title", "web", meeting_id)

    return response;
}

export async function untilNow(meeting_id)
{
    const response = await fetch(ServerURL + "/untilNow/" + meeting_id);
    const data = await response.json();

    return data
}


export async function shareMeeting(meeting_id, form)
{
    form.append('meeting_id', meeting_id);

    var response = await fetch(ServerURL+"/share_meeting", {
        method: 'POST', 
        mode: 'cors', 
        body: form
    });

    response = await response.json();
    matomoEvent("share meeting", "web", meeting_id)

    return response;
}

export async function create_recovery_link(email)
{
    const response = await fetch(ServerURL + "/create_recovery_link/" + email);
    const data = await response.json();
    return data
}

export async function use_recovery_link(link, passwd)
{
    var form = new FormData();    //formdata object

    form.append('link', link);   //append the values with key, value pair
    form.append('password', passwd);

    var response = await fetch(ServerURL+"/use_recovery_link", {
        method: 'POST', 
        mode: 'cors', 
        body: form
    });

    response = await response.json();

    return response;
}


export async function getAudio(meetingId, timestampBegin, timestampEnd)
{
    matomoEvent("get audio", "web", meetingId)
    return ServerURL + "/get_audio/" + meetingId + "/" + timestampBegin + "/" + timestampEnd
}


export async function transcribe(meeting_id)
{
    matomoEvent("transcribe", "web", meeting_id)
    fetch(ServerURL + "/transcribe/" + meeting_id);
    return true;
}


export async function ping(meeting_id)
{
    fetch(ServerURL + "/ping/" + meeting_id);
}